import { TrackingApi } from '@weddingspot/ws-api-client';
import { IS_NODE_SERVER } from '../constants/config';
import { Middleware, MiddlewareAPI, Dispatch } from 'redux';
import { LocationChangeAction } from 'react-router-redux';
import * as querystring from 'query-string';

export const attributionMiddleware: Middleware =
    (store: MiddlewareAPI) =>
    (next: Dispatch) =>
    <A extends LocationChangeAction>(action: A) => {
        if (IS_NODE_SERVER) {
            return next(action);
        }

        if (action.type === '@@router/LOCATION_CHANGE') {
            const nextParams = `${action.payload.search}`;
            let referer;
            if (typeof document !== 'undefined') {
                referer = document.referrer;
            }

            if (!nextParams && !referer) {
                return next(action);
            }

            if (!!nextParams) {
                const paramsObj = querystring.parse(nextParams);
                TrackingApi.trackReferrals(paramsObj as any);
            } else {
                TrackingApi.trackReferrals({
                    HTTP_REFERER: referer,
                });
            }
        }

        return next(action);
    };
